import { render } from "./MortgageCalculatorPage.vue?vue&type=template&id=4c21d3e1&scoped=true"
import script from "./MortgageCalculatorPage.vue?vue&type=script&lang=js"
export * from "./MortgageCalculatorPage.vue?vue&type=script&lang=js"

import "./MortgageCalculatorPage.vue?vue&type=style&index=0&id=4c21d3e1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c21d3e1"]])

export default __exports__